import './index.scss';

const ErrorMessage = ({ className = '', children, ...rest }) => (
    <span className={`error-message ${className}`} {...rest}>
        {children}
    </span>
);

export default ErrorMessage;
